import {
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import { Issue } from '../../issues/components/issue';
import { ActivityEditColumn } from './activityEditColumn';

export const ActivityEdit = () => {

  const leftColumn = {
    title: 'activities.detail.title',
    showHeader: false,
    disableScroll: true,
    mainComponent: <Issue isComingFromActivities />,
  };

  const rightColumn = {
    title: 'issue.menu.edit',
    mainComponent: <ActivityEditColumn />,
    showBackButton: true,
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
